import { useTranslation } from 'react-i18next';
import { WordBrowser, WordPreview } from '@entities/Word';
import type { Word } from '@shared/types';
import './Library.css';

interface PublicCardsBrowserProps {
  cards: Word[];
  /** ≤900px: слово открывается нижним листом, а не в панели справа. */
  mobile: boolean;
}

/** Слова публичного модуля: список и карточка выбранного слова (общий WordBrowser). */
export function PublicCardsBrowser({ cards, mobile }: PublicCardsBrowserProps) {
  const { t } = useTranslation();
  return (
    <div className="lb-body">
      <WordBrowser
        words={cards}
        mobile={mobile}
        mobileRow="inline"
        keysHint
        header={
          <div className="lb-list-head">
            <h2 className="lb-list-title">{t('library.detail.cardsHeading', { n: cards.length })}</h2>
            <span className="lb-list-hint">{t('library.detail.pickHint')}</span>
          </div>
        }
        empty={<div className="lb-no-cards">{t('library.detail.noCards')}</div>}
        renderPreview={(word) => <WordPreview word={word} />}
      />
    </div>
  );
}
